exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".card[data-v-04f370aa]:hover{background:#f5f8fa;border-radius:8px}.card[data-v-04f370aa]{padding:10px;cursor:pointer}", "", {"version":3,"sources":["/./src/components/app/general_notification_components/BaseNotifications.vue"],"names":[],"mappings":"AACA,6BACE,mBAAoB,AACpB,iBAAmB,CACpB,AACD,uBACE,aAAc,AACd,cAAgB,CACjB","file":"BaseNotifications.vue","sourcesContent":["\n.card[data-v-04f370aa]:hover {\n  background: #f5f8fa;\n  border-radius: 8px;\n}\n.card[data-v-04f370aa] {\n  padding: 10px;\n  cursor: pointer;\n}\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/vue-loader/lib/style-rewriter.js?id=data-v-04f370aa&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/app/general_notification_components/BaseNotifications.vue
// module id = 603
// module chunks = 2